import React from 'react';
import { Row, Col, Layout, message } from 'antd'
import { connect } from 'react-redux';
import moment from 'moment'
import get from 'lodash/get'

import Footer from '../../components/Footer/Footer'
import { consentServices } from "../../services"
import classes from './Consent.css'
import ConsentForm from '../../components/Consent/Consent'

import { consentUpdate } from "../../reducers/consent/actions";

const routes = require('../../routes.json');

const { Content } = Layout;


class ConsentComponent extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            currentStep: 'Step 1',
            currentStepType: '',
            currentStepInt: 1,
            subjectID: '',
            userID: '',
            siteID: '',
            consentType: '',
            consentPersonType: '',
            consentMethodType: '',
            fullName: '',
            dateOfBirth: '',
            signature: '',
            sigPad: {},
            representativeFullName: '',
            witnessFullName: '',
            witnessSignature: '',
            witnessSigPad: {},
            investigatorFullName: '',
            investigatorSignature: '',
            investigatorSigPad: {},
            date: '',
            consentFile: {},
            consentFileDc: {},
            consentFileWithdraw: {},
            fileList: {},
            dataset: {},
            fileListDc: {},
            datasetdc: {},
            fileListWithdraw: {},
            datasetwithdraw: {},
            consentProvided: '',
            consentOption: '',
            consentPaperBlankLink: '',
            consentPaperUpload: '',
            consentExists: false,
            consentExistsOverwrite: true,
            consentExistsType: '',
            consentExistsPersonType: '',
            consentExistsMethodType: '',
            consentExistsEmailStatus: '',
            consentExistsLink: '',
            consentExistsDate: '',
            consentSaved: false,
            consentSavedLink: '',
            submitted: false,
            loading: false,
            has_randomization_platform_step_3_patient: false,
            randomization_platform_step_3_patient_content: '',
            has_randomization_platform_step_3_patient_regained_capacity: false,
            randomization_platform_step_3_patient_regained_capacity_content: '',
            has_randomization_platform_step_3_surrogate: false,
            randomization_platform_step_3_surrogate_content: '',
            has_randomization_platform_step_3_withdraw: false,
            randomization_platform_step_3_withdraw_content: '',
            has_randomization_platform_step_3_deferred: false,
            randomization_platform_step_3_deferred_content: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDatePickerChange = this.handleDatePickerChange.bind(this);
        this.handleSigChange = this.handleSigChange.bind(this);
        this.handleWitnessSigChange = this.handleWitnessSigChange.bind(this);
        this.handleInvestigatorSigChange = this.handleInvestigatorSigChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.fileDummyRequest = this.fileDummyRequest.bind(this);
        this.normFile = this.normFile.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
    }

    async componentDidMount() {
      const token = get(this.props, 'match.params.token');
      if (token) {
        this.setState({
          currentStep: 'Step 3a',
          currentStepType: 'step2patientEmail',
          // consentPersonType: 'Patient',
          consentOverwrite: 'yes',
          consentMethodType: 'Email',
          investigatorFullName: 'TestName'
        });

        try {
          const { data } = await consentServices.getConsentByToken(token);
          this.setState({ ...data, consentPersonType: data.consentExistsPersonType, consentMethodType: data.consentExistsMethodType });
        } catch (e) {
          this.handleReset();
          this.props.history.push('/consent_error');
        }
      }
    }

  handleChange = event => {
      const {name, value} = event.target;
      this.setState({
        [name]: value
      })
    }

    handleDatePickerChange = event => {
      this.setState({
        dateOfBirth: event
      })
    }


    handleSigChange = event => {
      this.setState({
        signature: event
      }, () => {
        // console.log(this.state.signature);
        console.log('');
      });
    }


    handleWitnessSigChange = event => {
      this.setState({
        witnessSignature: event
      }, () => {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    }

    handleInvestigatorSigChange = event => {
      this.setState({
        investigatorSignature: event
      }, () => {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    }

    handleFileChange = event => {
      this.setState({
        consentFile: event
      }, () => {
        //console.log(this.state.witnessSignature);
        console.log('');
      });
    }

    fileDummyRequest ({ file, onSuccess }) {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);

    }

    normFile(e) {
        // console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        if (e.fileList.length > 1) {
            e.fileList.shift();
        }

        this.setState({
            fileList: e.fileList
        }, () => {
            //console.log(this.state.fileList);
            console.log('');
        });

        return e && e.fileList;
    }


    handleSubmit(values) {

        const token = get(this.props, 'match.params.token');

        this.setState({
            loading: true,
            currentStep: 'Step 4',
            currentStepInt: 4
        });

        if (token) {
          consentServices.confirmConsentByToken(token, {...values, ...this.state }).then(
            response => {
              const consentResponse = response.data;
            },
            error => {
              if (error.response) {
                const errors = error.response.data.error;
                if (errors) {
                  message.config({ style: { color: '#424242' } });
                  message.error(errors, 5);
                }
              }

              this.setState({
                consentExists: false,
                consentExistsLink: '',
                consentSaved: false,
                consentSavedLink: '',
                submitted: false,
                loading: false
              });
            });
        } else {
          consentServices.create(values)
            .then(
              response => {
                const consentResponse = response.data;
              },
              error => {
                if (error.response) {
                  const errors = error.response.data.error;
                  if (errors) {
                    message.config({ style: { color: '#424242' } })
                    message.error(errors, 5)
                  }
                }

                this.setState({
                  consentExists: false,
                  consentExistsLink: '',
                  consentSaved: false,
                  consentSavedLink: '',
                  submitted: false,
                  loading: false
                });
              });
        }
    }

    handleReset() {
        this.setState({
            currentStep: 'Step 1',
            currentStepInt: 1,
            subjectID: '',
            userID: '',
            siteID: '',
            consentType: '',
            consentPersonType: '',
            consentMethodType: '',
            currentStepType: '',
            fullName: '',
            dateOfBirth: '',
            signature: '',
            witnessSignature: '',
            witnessFullName: '',
            representativeFullName: '',
            investigatorSignature: '',
            investigatorFullName: '',
            date: '',
            consentFile: {},
            consentFileDc: {},
            consentFileWithdraw: {},
            fileList: {},
            dataset: {},
            fileListDc: {},
            datasetdc: {},
            fileListWithdraw: {},
            datasetwithdraw: {},
            consentProvided: '',
            consentOption: '',
            consentPaperBlankLink: '',
            consentPaperUpload: '',
            consentExists: false,
            consentExistsOverwrite: false,
            consentExistsType: '',
            consentExistsPersonType: '',
            consentExistsMethodType: '',
            consentExistsEmailStatus: '',
            consentExistsDate: '',
            consentExistsLink: '',
            consentSaved: false,
            consentSavedLink: '',
            submitted: false,
            loading: false,
            has_randomization_platform_step_3_patient: false,
            randomization_platform_step_3_patient_content: '',
            has_randomization_platform_step_3_patient_regained_capacity: false,
            randomization_platform_step_3_patient_regained_capacity_content: '',
            has_randomization_platform_step_3_surrogate: false,
            randomization_platform_step_3_surrogate_content: '',
            has_randomization_platform_step_3_withdraw: false,
            randomization_platform_step_3_withdraw_content: '',
            has_randomization_platform_step_3_deferred: false,
            randomization_platform_step_3_deferred_content: ''
        })
    }


    handleNext(values) {
      let {currentStep, currentStepInt} = this.state;
      const token = get(this.props, 'match.params.token');

      if (currentStep === 'Step 1') {
        this.setState({
          loading: true
        });

        consentServices.create(this.state)
            .then(
                response => {
                    const consentResponse = response.data;

                    if (get(consentResponse, 'consent_workflow_type') === "edmonton") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentType2);
                    } else if (get(consentResponse, 'consent_workflow_type') === "sunnybrook") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeSunnybrook);
                    } else if (get(consentResponse, 'consent_workflow_type') === "toronto_uh") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeTorontoUH);
                    } else if (get(consentResponse, 'consent_workflow_type') === "kelowna") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeKelowna);
                    } else if (get(consentResponse, 'consent_workflow_type') === "montreal") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeMontreal);
                    } else if (get(consentResponse, 'consent_workflow_type') === "vancouver") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeVancouver);
                    } else if (get(consentResponse, 'consent_workflow_type') === "winnipeg") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeWinnipeg);
                    } else if (get(consentResponse, 'consent_workflow_type') === "uhn") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeUhn);
                    } else if (get(consentResponse, 'consent_workflow_type') === "halifax") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeHalifax);
                    } else if (get(consentResponse, 'consent_workflow_type') === "lhs") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeLhs);
                    } else if (get(consentResponse, 'consent_workflow_type') === "grey_nuns") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeGreyNuns);
                    } else if (get(consentResponse, 'consent_workflow_type') === "red_deer") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeRedDeer);
                    } else if (get(consentResponse, 'consent_workflow_type') === "medicine_hat") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeMedicineHat);
                    } else if (get(consentResponse, 'consent_workflow_type') === "lethbridge") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeLethbridge);
                    } else if (get(consentResponse, 'consent_workflow_type') === "kingston") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeKingston);
                    } else if (get(consentResponse, 'consent_workflow_type') === "quebec_chu") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeQuebecChu);
                    } else if (get(consentResponse, 'consent_workflow_type') === "chus") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeChus);
                    } else if (get(consentResponse, 'consent_workflow_type') === "hamilton") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeHamilton);
                    } else if (get(consentResponse, 'consent_workflow_type') === "ottawa") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeOttawa);
                    } else if (get(consentResponse, 'consent_workflow_type') === "royal_university") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeRoyalUniversity);
                    }  else if (get(consentResponse, 'consent_workflow_type') === "royal") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypeRoyal);
                    } else if (get(consentResponse, 'consent_workflow_type') === "pei") {
                      this.props.consentUpdate({ ...consentResponse, siteID: this.state.siteID, userID: this.state.userID });
                      this.props.history.push(routes.front.consentTypePei);
                    } else {
                      this.setState({
                        currentStep: 'Step 2',
                        currentStepInt: 2,
                        subjectID: consentResponse['subjectID'],
                        consentType: '',
                        consentPersonType: '',
                        consentMethodType: '',
                        currentStepType: '',
                        fullName: '',
                        dateOfBirth: '',
                        signature: '',
                        witnessSignature: '',
                        witnessFullName: '',
                        representativeFullName: '',
                        investigatorSignature: '',
                        investigatorFullName: '',
                        date: consentResponse['consentDate'],
                        consentDate: consentResponse['consentDate'],
                        consentFile: {},
                        consentFileDc: {},
                        consentFileWithdraw: {},
                        fileList: {},
                        dataset: {},
                        consentProvided: '',
                        consentOption: '',
                        consentPaperBlankLink: '',
                        consentPaperUpload: '',
                        consentExists: consentResponse['consentExists'],
                        consentExistsOverwrite: false,
                        consentExistsType: consentResponse['consentExistsType'],
                        consentExistsPersonType: consentResponse['consentExistsPersonType'],
                        consentExistsMethodType: consentResponse['consentExistsMethodType'],
                        consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'],
                        consentExistsDate: consentResponse['consentExistsDate'],
                        consentExistsLink: consentResponse['consentExistsLink'],
                        consentSaved: false,
                        consentSavedLink: '',
                        submitted: false,
                        loading: false,
                        has_randomization_platform_step_3_patient: consentResponse['has_randomization_platform_step_3_patient'],
                        randomization_platform_step_3_patient_content: consentResponse['randomization_platform_step_3_patient_content'],
                        has_randomization_platform_step_3_patient_regained_capacity: consentResponse['has_randomization_platform_step_3_patient_regained_capacity'],
                        randomization_platform_step_3_patient_regained_capacity_content: consentResponse['randomization_platform_step_3_patient_regained_capacity_content'],
                        has_randomization_platform_step_3_surrogate: consentResponse['has_randomization_platform_step_3_surrogate'],
                        randomization_platform_step_3_surrogate_content: consentResponse['randomization_platform_step_3_surrogate_content'],
                        has_randomization_platform_step_3_withdraw: consentResponse['has_randomization_platform_step_3_withdraw'],
                        randomization_platform_step_3_withdraw_content: consentResponse['randomization_platform_step_3_withdraw_content'],
                        has_randomization_platform_step_3_deferred: consentResponse['has_randomization_platform_step_3_deferred'],
                        randomization_platform_step_3_deferred_content: consentResponse['randomization_platform_step_3_deferred_content']
                      });
                    }
                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.setState({
                        currentStep: 'Step 1',
                        currentStepInt: 1,
                        consentType: '',
                        consentPersonType: '',
                        consentMethodType: '',
                        currentStepType: '',
                        fullName: '',
                        dateOfBirth: '',
                        signature: '',
                        witnessSignature: '',
                        witnessFullName: '',
                        representativeFullName: '',
                        investigatorSignature: '',
                        investigatorFullName: '',
                        date: '',
                        consentFile: {},
                        consentFileDc: {},
                        consentFileWithdraw: {},
                        fileList: {},
                        dataset: {},
                        fileListDc: {},
                        datasetdc: {},
                        fileListWithdraw: {},
                        datasetwithdraw: {},
                        consentProvided: '',
                        consentOption: '',
                        consentPaperBlankLink: '',
                        consentPaperUpload: '',
                        consentExists: false,
                        consentExistsOverwrite: false,
                        consentExistsType: '',
                        consentExistsPersonType: '',
                        consentExistsMethodType: '',
                        consentExistsEmailStatus: '',
                        consentExistsDate: '',
                        consentExistsLink: '',
                        consentSaved: false,
                        consentSavedLink: '',
                        submitted: false,
                        loading: false,
                        has_randomization_platform_step_3_patient: false,
                        randomization_platform_step_3_patient_content: '',
                        has_randomization_platform_step_3_patient_regained_capacity: false,
                        randomization_platform_step_3_patient_regained_capacity_content: '',
                        has_randomization_platform_step_3_surrogate: false,
                        randomization_platform_step_3_surrogate_content: '',
                        has_randomization_platform_step_3_withdraw: false,
                        randomization_platform_step_3_withdraw_content: '',
                        has_randomization_platform_step_3_deferred: false,
                        randomization_platform_step_3_deferred_content: ''
                    })
                });

      } else if ((currentStep === 'Step 2') && (this.state.consentMethodType === 'Electronic') ) {
        this.setState({
          currentStep: 'Step 3a',
          currentStepInt: 3,
          consentExistsOverwrite: true
        })
      } else if ((currentStep === 'Step 2') && (this.state.consentMethodType === 'Email' || this.state.consentMethodType === 'EmailRegainedCapacity') ) {
        this.setState({
          currentStep: 'Step 3a',
          currentStepInt: 3,
          consentExistsOverwrite: true
        })
      } else if ( (currentStep === 'Step 2') && (this.state.consentMethodType === 'Paper') ) {
        this.setState({
          currentStep: 'Step 3b',
          currentStepInt: 3,
          consentExistsOverwrite: true
        })
      } else if ( (currentStep === 'Step 2') && (this.state.consentMethodType === 'RegainedCapacity') ) {
        this.setState({
          currentStep: 'Step 3a',
          currentStepInt: 3,
          consentExistsOverwrite: true
        })
      } else if ( (currentStep === 'Step 3a') && (this.state.consentExistsOverwrite) && (this.state.consentProvided === 'yes') ) {
        if (values['dateOfBirth']) {
          values['dateOfBirth'] = moment.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD')
        }

        // window.alert('step 3 submit: DOB: ' + values['dateOfBirth'] + ' .. ' + moment.utc(values['dateOfBirth'], 'YYYY-MM-DD').local().format('YYYY-MM-DD') + ' .. ' + Date())

        this.setState({
          loading: true
        });

        if (token) {
          consentServices.confirmConsentByToken(token, this.state, values['dateOfBirth'], values['signature'], values['witnessSignature'], values['investigatorSignature']).then(
            response => {
              const consentResponse = response.data;

              this.setState({
                currentStep: 'Step 4',
                currentStepInt: 4,
                subjectID: consentResponse['subjectID'],
                consentType: '',
                consentPersonType: '',
                consentMethodType: '',
                currentStepType: '',
                fullName: '',
                dateOfBirth: '',
                signature: '',
                witnessSignature: '',
                witnessFullName: '',
                representativeFullName: '',
                investigatorSignature: '',
                investigatorFullName: '',
                date: consentResponse['consentDate'],
                consentProvided: '',
                consentOption: '',
                consentPaperBlankLink: '',
                consentPaperUpload: '',
                consentExists: consentResponse['consentExists'],
                consentExistsOverwrite: true,
                consentExistsType: consentResponse['consentExistsType'],
                consentExistsPersonType: consentResponse['consentExistsPersonType'],
                consentExistsMethodType: consentResponse['consentExistsMethodType'],
                consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'],
                consentExistsDate: consentResponse['consentExistsDate'],
                consentExistsLink: consentResponse['consentExistsLink'],
                consentSaved: false,
                consentSavedLink: '',
                submitted: false,
                loading: false
              });
            },
            error => {
              if (error.response) {
                const errors = error.response.data.error;
                if (errors) {
                  message.config({ style: { color: '#424242' } });
                  message.error(errors, 5)
                }
              }

              this.handleReset()
            });
        } else {
          consentServices.create(this.state, values['dateOfBirth'], values['signature'], values['witnessSignature'], values['investigatorSignature'])
            .then(
              response => {
                const consentResponse = response.data;

                this.setState({
                  currentStep: 'Step 4',
                  currentStepInt: 4,
                  subjectID: consentResponse['subjectID'],
                  consentType: '',
                  consentPersonType: '',
                  consentMethodType: '',
                  currentStepType: '',
                  fullName: '',
                  dateOfBirth: '',
                  signature: '',
                  witnessSignature: '',
                  witnessFullName: '',
                  representativeFullName: '',
                  investigatorSignature: '',
                  investigatorFullName: '',
                  date: consentResponse['consentDate'],
                  consentProvided: '',
                  consentOption: '',
                  consentPaperBlankLink: '',
                  consentPaperUpload: '',
                  consentExists: consentResponse['consentExists'],
                  consentExistsOverwrite: true,
                  consentExistsType: consentResponse['consentExistsType'],
                  consentExistsPersonType: consentResponse['consentExistsPersonType'],
                  consentExistsMethodType: consentResponse['consentExistsMethodType'],
                  consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'],
                  consentExistsDate: consentResponse['consentExistsDate'],
                  consentExistsLink: consentResponse['consentExistsLink'],
                  consentSaved: false,
                  consentSavedLink: '',
                  submitted: false,
                  loading: false
                });
              },
              error => {
                if (error.response) {
                  const errors = error.response.data.error;
                  if (errors) {
                    message.config({ style: { color: '#424242' } })
                    message.error(errors, 5)
                  }
                }

                this.handleReset()
              });

        }
      } else if ( (currentStep === 'Step 3b') && (this.state.consentExistsOverwrite) ) {

        this.setState({
          loading: true
        })

//        console.log(values['consentFile'])
//        console.log(this.state.fileList)

        consentServices.create(this.state, '', '', '', '', values['consentFile'])
            .then(
                response => {
                    const consentResponse = response.data;

                    this.setState({
                        currentStep: 'Step 4',
                        currentStepInt: 4,
                        subjectID: consentResponse['subjectID'],
                        consentType: '',
                        consentPersonType: '',
                        consentMethodType: '',
                        currentStepType: '',
                        fullName: '',
                        dateOfBirth: '',
                        signature: '',
                        witnessSignature: '',
                        witnessFullName: '',
                        representativeFullName: '',
                        investigatorSignature: '',
                        investigatorFullName: '',
                        date: consentResponse['consentDate'],
                        consentFile: {},
                        fileList: {},
                        dataset: {},
                        consentProvided: '',
                        consentOption: '',
                        consentPaperBlankLink: '',
                        consentPaperUpload: '',
                        consentExists: consentResponse['consentExists'],
                        consentExistsOverwrite: true,
                        consentExistsType: consentResponse['consentExistsType'],
                        consentExistsPersonType: consentResponse['consentExistsPersonType'],
                        consentExistsMethodType: consentResponse['consentExistsMethodType'],
                        consentExistsEmailStatus: consentResponse['consentExistsEmailStatus'],
                        consentExistsDate: consentResponse['consentExistsDate'],
                        consentExistsLink: consentResponse['consentExistsLink'],
                        consentSaved: false,
                        consentSavedLink: '',
                        submitted: false,
                        loading: false
                    });
                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.handleReset()
                });

      } else {
          this.handleReset()
      }

    }

    handlePrev = () => {
      let {currentStep, currentStepInt} = this.state
      if (currentStep === 'Step 2') {
            this.handleReset()
      } else if (currentStep === 'Step 3a') {
            this.handleReset()
      } else if (currentStep === 'Step 3b') {
            this.handleReset()
      }

    }


    render() {
        const { loading, consentSaved } = this.state;
        const token = get(this.props, 'match.params.token');

        return (
            <div style={{ backgroundColor: '#FAFAFA' }}>
                <Layout className={classes.parentContainer}>
                    <Content className={classes.content}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>

                                <ConsentForm token={token} loading={loading} {...this.state} handleChange={this.handleChange} handleDatePickerChange={this.handleDatePickerChange} handleSigChange={this.handleSigChange} handleWitnessSigChange={this.handleWitnessSigChange} handleInvestigatorSigChange={this.handleInvestigatorSigChange} handleFileChange={this.handleFileChange} fileDummyRequest={this.fileDummyRequest} normFile={this.normFile} handleSubmit={this.handleSubmit} handleNext={this.handleNext} handlePrev={this.handlePrev}/>




                            </Col>
                        </Row>
                    </Content>
                    <Footer />
                </Layout>
            </div>
        );
    }
}

const mapDispatchToProps = { consentUpdate };

export default connect(() => ({}), mapDispatchToProps)(ConsentComponent);



// WEBPACK FOOTER //
// ./src/containers/Consent/Consent.js